import { render, staticRenderFns } from "./ButtonPanel.vue?vue&type=template&id=5c8658d8&scoped=true"
import script from "./ButtonPanel.vue?vue&type=script&lang=ts"
export * from "./ButtonPanel.vue?vue&type=script&lang=ts"
import style0 from "./ButtonPanel.vue?vue&type=style&index=0&id=5c8658d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8658d8",
  null
  
)

export default component.exports